// extracted by mini-css-extract-plugin
module.exports = {"container":"zoetrope-module--container--38hw_","visible":"zoetrope-module--visible--2dUrN","mask":"zoetrope-module--mask--2XZEU","is_playing":"zoetrope-module--is_playing--3Ct5e"};